import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: {
        if: [
          [
            {
              '!=': [
                {
                  '@': 'editingActivity',
                },
                null,
              ],
            },
            'Edit Activity',
          ],
          'Create New Activity',
        ],
      },
      type: 'details',
      content: {
        '{}': {
          fields: {
            '[]': [
              {
                '{}': {
                  id: 'name',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!subaward_monitor_acts#!activity:!name',
                        },
                      },
                    },
                  },
                  value: {
                    '@>': [
                      {
                        '@': 'editingActivity',
                      },
                      'name',
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'descr',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!subaward_monitor_acts#!activity:!descr',
                        },
                      },
                    },
                  },
                  value: {
                    '@>': [
                      {
                        '@': 'editingActivity',
                      },
                      'descr',
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'always_recommend',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!subaward_monitor_acts#!activity:!always_recommend',
                        },
                      },
                    },
                  },
                  value: {
                    '@>': [
                      {
                        '@': 'editingActivity',
                      },
                      'alwaysRecommend',
                    ],
                  },
                },
              },
            ],
          },
          onSave: {
            '{}': {
              action: {
                '{}': {
                  alias: 'sr.save-activity',
                },
              },
              variables: {
                '{}': {
                  activityId: {
                    '@$': 'activityId',
                  },
                  activityName: '${field:name}',
                  activityDescr: '${field:descr}',
                  activityAlwaysRecommend: '${field:always_recommend}',
                },
              },
            },
          },
        },
      },
    },
  },
  subqueries: {
    editingActivity: {
      filter: {
        '=': [
          {
            '@.': '!id',
          },
          {
            '@$': 'activityId',
          },
        ],
      },
      quantity: 1,
      target: 'ent:!subaward_monitor_acts:!activity',
      selection: {
        '{}': {
          name: {
            '@.': '!name',
          },
          descr: {
            '@.': '!descr',
          },
          alwaysRecommend: {
            '@.': '!always_recommend',
          },
        },
      },
    },
  },
}
